<template>
<div class="chapter">
<div class="inner_page">
<p class="p0"><img alt="cover.jpg" height="675" src="images/cover.jpg" width="450"/><span class="t1">渍</span></p>
<p class="p0"><span class="t2">Sunrise: Whitney</span></p>
<p class="p0">By Tim Mead</p>
<p class="p0"> </p>
<p class="p0">Published by <a href="http://www.jms-books.com" target="_blank"><span class="t3">JMS </span><span class="t3">Books</span><span class="t3"> LLC</span></a></p>
<p class="p0">Visit <a href="http://www.jms-books.com" target="_blank"><span class="t3">jms-books.com</span></a> for more information.</p>
<p class="p0"> </p>
<p class="p0">Copyright 2024 Tim Mead</p>
<p class="p0">ISBN 9781685506568</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 001.vue?0483e1de